export const ERROR_CODE = {
    blocked: 408,
    authOver: 409
};
